<template>
    <b-collapse class="card filters-collapse" :open.sync="showFilters">
        <div slot="trigger" class="card-header filters-trigger">
            <p class="card-header-title">{{ $t('filters') }}</p>
            <a class="card-header-icon">
                <b-icon pack="fa" v-show="!showFilters" icon="plus-circle" />
                <b-icon pack="fa" v-show="showFilters" icon="minus-circle" />
            </a>
        </div>
        <div class="panel" style="border-width: 0">
            <div class="filters-row mb-4">
                <div class="filter-item">
                    <b-field :label="$t('action')">
                        <b-select v-model="filterAction" :placeholder="$t('select_action')" @input="applyFilters"
                            expanded>
                            <option value="">{{ $t('all') }}</option>
                            <option v-for="action in actionsList" :key="action.value" :value="action.value">
                                {{ $t(action.label) }}
                            </option>
                        </b-select>
                    </b-field>
                </div>
                <div class="filter-item">
                    <b-field :label="$t('entity')">
                        <b-select v-model="filterEntity" :placeholder="$t('select_entity')" @input="applyFilters"
                            expanded>
                            <option value="">{{ $t('all') }}</option>
                            <option v-for="entity in entitiesList" :key="entity.value" :value="entity.value">
                                {{ $t(entity.label) }}
                            </option>
                        </b-select>
                    </b-field>
                </div>
                <div class="filter-item">
                    <b-field :label="$t('project')">
                        <b-input v-model="filterProject" :placeholder="$t('project_name_placeholder')" icon="folder"
                            icon-pack="fas" @input="applyFilters" />
                    </b-field>
                </div>
                <div class="filter-item filter-dates">
                    <div class="dates-row">
                        <b-field :label="$t('date_start')">
                            <b-datepicker v-model="filterDateFrom" :placeholder="$t('date_start')" icon="calendar"
                                icon-pack="fas" @input="applyFilters" />
                        </b-field>
                        <b-field :label="$t('date_end')">
                            <b-datepicker v-model="filterDateTo" :placeholder="$t('date_end')" icon="calendar"
                                icon-pack="fas" @input="applyFilters" />
                        </b-field>
                    </div>
                </div>
            </div>
            <button class="button is-primary btn-blue" @click="cleanFiltersClicked()">{{ $t('clean_filters') }}</button>
        </div>
    </b-collapse>
</template>



<script>
import { Collapse, Field, Input, Select, Icon, Datepicker } from 'buefy'

export default {
    name: 'worklog-filters',
    components: { Collapse, Field, Input, Select, Icon, Datepicker },

    data() {
        return {
            showFilters: false,
            filterUser: '',
            filterAction: '',
            filterEntity: '',
            filterProject: '',
            filterDateFrom: null,
            filterDateTo: null,
            actionsList: [
                { value: 0, label: 'create' },
                { value: 1, label: 'update' },
                { value: 2, label: 'delete' },
                { value: 3, label: 'progress_label' },
                { value: 4, label: 'activity_status' },
                { value: 5, label: 'mention' },
                { value: 6, label: 'add_user' },
                { value: 7, label: 'remove_user' },
                { value: 8, label: 'opened' },
                { value: 9, label: 'close' },
                // { value: 10, label: 'access_type' }, opciones no interesantes para historial
                { value: 11, label: 'completed' },
                { value: 12, label: 'import_locations' },
                { value: 13, label: 'import_activities' },
                { value: 15, label: 'import_assignments' },
                { value: 19, label: 'bulk_action' },
                // { value: 20, label: 'bulk_action_silent' },
                { value: 21, label: 'upload_version' },
                // { value: 22, label: 'activity_progress_actual' },
            ],
            entitiesList: [
                { value: 0, label: 'activity' },
                { value: 1, label: 'subactivity' },
                { value: 2, label: 'issue' },
                { value: 3, label: 'document' },
                { value: 4, label: 'comment' },
                { value: 5, label: 'project' },
                { value: 6, label: 'issue_comment' },
                { value: 7, label: 'area' },
                { value: 8, label: 'assignment' },
                { value: 9, label: 'validation' },
                { value: 10, label: 'folder' },
            ]
        }
    },
    methods: {
        applyFilters() {
            this.$emit('filters-updated', {
                user: this.filterUser,
                action_type: this.filterAction,
                entity_type: this.filterEntity,
                project: this.filterProject,
                dateFrom: this.filterDateFrom,
                dateTo: this.filterDateTo,
            })
        },
        cleanFiltersClicked() {
            this.filterUser = ''
            this.filterAction = ''
            this.filterEntity = ''
            this.filterProject = ''
            this.filterDateFrom = null
            this.filterDateTo = null
            this.applyFilters()
        }
    }
}
</script>

<style scoped>
.filters-row {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}

.filter-item {
    flex: 1 1 220px;
    min-width: 220px;
    max-width: 100%;
}

.filter-dates .dates-row {
    display: flex;
    gap: 1rem;
}

.filter-dates .b-field {
    flex: 1 1 120px;
    min-width: 120px;
}
</style>